module.exports = __webpack_public_path__ + "c67bbad2a46ba60f83754924a189b5b3.png";